/**
 * Get the appropriate user profile placeholder based on theme
 * @param {string} theme - Current theme ('light' or 'dark')
 * @returns {string} - Path to the appropriate placeholder
 */
export function getUserProfilePlaceholder(theme) {
    return theme === 'dark' 
        ? '/images/user-profile-placeholder-dark.svg' 
        : '/images/user-profile-placeholder-light.svg';
}
